// @ts-check

/**
 * Configure checkout-rules:
 */
angular.module('checkout').run(
    [
        //'checkoutRulesConfig',
        'rcmApiLibService',
        'translateFilter',
        'pageRequirementsConfig',
        function (
            //checkoutRulesConfig,
            rcmApiLibService,
            translateFilter,
            pageRequirementsConfig
        ) {
            pageRequirementsConfig.configure();
            // @todo Get this message from server Checkout Messages
            rcmApiLibService.config.defaultMessage = translateFilter('An error occurred. Please try again. For further assistance, please call Reliv\'s Distributor Services Center at 1-800-RELIV US (735.4887).');
        },
    ]
);
